import BasicService from "./BasicService";

class CustomerService extends BasicService {
  constructor() {
    super();
  }

  getcustomers() {
    let url = `/customers`
    return this.axios.get(url).then(request => request.data);
  }
  saveCustomers(customer) {
    let url = `/customers`
    return this.axios.post(url,customer).then(request => request.data);
  }
  updateCustomers(customer) {
    let url = `/customers/${customer.customerId}`
    return this.axios.put(url,customer).then(request => request.data);
  }
  deleteCustomers(customer) {
    let url = `/customers/${customer.customerId}`
    return this.axios.delete(url).then(request => request.data);
  }
}

const accountUserService = new CustomerService();
export default accountUserService;